/* BlackHype (2026-10-08): liga e desliga o cartão de personalização conforme a opção de variante,
   informa o código do time para a lista de jogadores e impede enviar "Customize" sem nome nem número. */
(function () {
  'use strict';
  var NAO = /^\s*(not|no|none|don'?t|without|sem|sin|sans|ohne|senza)\b/i;

  function valorDaOpcao(pos) {
    var picker = document.querySelector('product-info variant-selects, variant-selects, variant-radios');
    if (!picker) return null;
    var grupos = picker.querySelectorAll('fieldset, .product-form__input--dropdown, .product-form__input');
    var vistos = [];
    for (var i = 0; i < grupos.length; i++) { if (vistos.indexOf(grupos[i]) < 0 && !vistos.some(function (g) { return g.contains(grupos[i]); })) vistos.push(grupos[i]); }
    var grupo = vistos[pos - 1];
    if (!grupo) return null;
    var marcado = grupo.querySelector('input[type="radio"]:checked');
    if (marcado) return marcado.value;
    var sel = grupo.querySelector('select');
    return sel ? sel.value : null;
  }

  function iniciar(raiz) {
    if (raiz.dataset.bhCzPronto === '1') return;
    raiz.dataset.bhCzPronto = '1';
    var pos = parseInt(raiz.getAttribute('data-bh-cz-pos'), 10) || 0;
    var campos = raiz.querySelectorAll('.md-ps-input');
    var erro = raiz.querySelector('[data-bh-cz-erro]');
    var formId = raiz.getAttribute('data-bh-cz-form');

    function etiqueta() {
      var txt = raiz.getAttribute('data-bh-cz-extra'); if (!txt) return;
      var picker = document.querySelector('product-info variant-selects, variant-selects'); if (!picker) return;
      var radios = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) { var n = radios[i].name || ''; if (!/custom|personal/i.test(n) || NAO.test(radios[i].value)) continue; var l = picker.querySelector('label[for="' + radios[i].id + '"]'); if (l && !l.querySelector('.bh-cz-tag')) { var s = document.createElement('span'); s.className = 'bh-cz-tag'; s.textContent = txt; l.appendChild(s); } }
    }
    function ligado() { var v = valorDaOpcao(pos); return !!v && !NAO.test(v); }
    function aplicar() {
      etiqueta();
      var on = ligado();
      for (var i = 0; i < campos.length; i++) campos[i].disabled = !on;
      if (on === !raiz.classList.contains('hidden')) return;
      raiz.classList.toggle('hidden', !on);
      if (erro) erro.hidden = true;
    }
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) { aplicar(); setTimeout(aplicar, 60); setTimeout(aplicar, 600); } });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, function () { requestAnimationFrame(aplicar); });
    for (var i = 0; i < campos.length; i++) campos[i].addEventListener('input', function () { if (erro) erro.hidden = true; });
    aplicar();

    // "Customize" marcado sem nome nem número: não envia, mostra o aviso
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.id !== formId || !ligado()) return;
      var vazio = true;
      for (var i = 0; i < campos.length; i++) if ((campos[i].value || '').trim()) vazio = false;
      if (!vazio) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (erro) erro.hidden = false;
      var jogador = raiz.querySelector('.md-jg-seletor');
      (jogador && !jogador.parentNode.hidden ? jogador : campos[0]).focus();
      raiz.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, true);

    // lista de jogadores: o código do time vem do bh-kits.json
    var jg = raiz.querySelector('[data-md-jg]');
    var url = raiz.getAttribute('data-bh-cz-kits');
    if (jg && url) {
      fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        var cod = d && d.teams && d.teams[raiz.getAttribute('data-bh-cz-handle')];
        if (!cod) return;
        jg.setAttribute('data-md-jg-cod', cod);
        var s = document.createElement('script'); s.src = raiz.getAttribute('data-bh-cz-jogadores'); s.defer = true; document.head.appendChild(s);
      }).catch(function () {});
    }
  }

  function todos() { var l = document.querySelectorAll('[data-bh-cz]'); for (var i = 0; i < l.length; i++) iniciar(l[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
})();
